import * as React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Button } from '@mui/material';

class LoginLogout extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loggedIn: this.props.loggedIn };
      }

    loginSuccess = (credentialResponse) => {
        const credential = credentialResponse.credential;
        this.props.onLoginSuccessCallback(credential);
        this.setState({
            loggedIn: true
          });
    }

    failure = (error) => {
        console.error('Login failed:', error);
      }
    
    logoutSuccess = () => {
        this.props.onLogoutSuccessCallback();
        this.setState({
            loggedIn: false
          });
    }

    render() {
        if (this.state.loggedIn) {
            return <Button
                variant="outlined"
                onClick={this.logoutSuccess}
            >
                Logout
            </Button>
        }
        else {
            return <GoogleLogin
                onSuccess={this.loginSuccess}
                onError={this.failure}
                useOneTap
            />
        }
    }
  }

export default LoginLogout